"use client";

import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ContactForm from "@/components/ContactForm";
import CorporateCollabCard from "@/components/CorporateCollabCard";
import WhatsAppCommunityCard from "@/components/WhatsAppCommunityCard";
import InstagramTeaser from "@/components/InstagramTeaser";
import FormSplitLayout from "@/components/FormSplitLayout";
import Reveal from "@/components/Reveal";
import { useTranslations } from "@/i18n/LocaleProvider";

export default function ContactPageView() {
  const { t } = useTranslations();
  return (
    <>
      <Header />
      <FormSplitLayout image="/images/devina/photo-17.jpg" imageAlt="Devina looking up at a hula hoop in a forest">
        <div className="mx-auto w-full max-w-lg py-2 sm:py-3">
          <Reveal>
            <p className="text-center text-sm font-semibold uppercase tracking-[0.2em] text-accent">
              {t("contactPage.eyebrow")}
            </p>
            <h1 className="mt-2 text-center font-display text-xl sm:text-2xl">
              {t("contactPage.title")}
            </h1>
            <p className="mt-2 text-center text-sm text-foreground/70">
              {t("contactPage.subtitle")}
            </p>
          </Reveal>
          <div className="mt-3 sm:mt-4">
            <ContactForm />
          </div>
        </div>
      </FormSplitLayout>
      <CorporateCollabCard />
      <section className="bg-background-alt">
        <div className="mx-auto max-w-[1440px] px-8 py-24">
          <InstagramTeaser />
        </div>
      </section>
      <WhatsAppCommunityCard />
      <Footer />
    </>
  );
}
